"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeAuthPage = changeAuthPage;
exports.getPasswordResetInfo = getPasswordResetInfo;
exports.login = login;
exports.logout = logout;
exports.redirect = redirect;
exports.requestPasswordReset = requestPasswordReset;
exports.resetPassword = resetPassword;
exports.resetPasswordAndLogin = resetPasswordAndLogin;
exports.sendMagicLink = sendMagicLink;
exports.setIsAuthenticated = setIsAuthenticated;
exports.validateMagicLink = validateMagicLink;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _authActionKeys = _interopRequireDefault(require("./authActionKeys"));

var _authService = _interopRequireDefault(require("./authService"));

var _cookieUtils = _interopRequireDefault(require("../utils/cookieUtils"));

var _redirectionUtils = _interopRequireDefault(require("../utils/redirectionUtils"));

var _analytics = require("../analytics");

var _authUtils = require("./authUtils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function changeAuthPage() {
  return {
    type: _authActionKeys.default.CHANGE_AUTH_PAGE
  };
}

function setIsAuthenticated(isAuthenticated) {
  return {
    type: _authActionKeys.default.SET_IS_AUTHENTICATED,
    payload: isAuthenticated
  };
}

function redirect() {
  return {
    type: _authActionKeys.default.REDIRECT,
    payload: _redirectionUtils.default.redirect()
  };
}

function login(username, password) {
  var skipRedirect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var trackProperties = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var loginFn = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _authService.default.login;
  return {
    type: _authActionKeys.default.LOGIN,
    payload: loginFn(username, password).then(function (result) {
      if (process.env.IS_BROWSER) {
        (0, _authUtils.setHaTaskTaxonomyTestCookie)();
        (0, _authUtils.setAuthTokenCookie)((0, _get2.default)(result, 'body.authToken'));
        var userId = (0, _get2.default)(result, 'body.user.id');

        if (trackProperties && !(Object.keys(trackProperties).length === 0 && Object.getPrototypeOf(trackProperties) === Object.prototype)) {
          _analytics.tracker.track('user login successful fe', _objectSpread({
            userId: userId
          }, trackProperties));
        } else {
          _analytics.tracker.track('user login successful fe', {
            userId: userId
          });
        }

        if (!skipRedirect) {
          setTimeout(_redirectionUtils.default.redirect, 50);
        }
      }

      return result;
    })
  };
}

function logout(userId) {
  var urlToRedirectTo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/login';
  return function (_ref) {
    var engine = _ref.engine;
    return {
      type: _authActionKeys.default.LOGOUT,
      payload: _authService.default.logout(userId).then(function (result) {
        if (engine) {
          engine.save({}); // Always reset client storage.
        }

        if (process.env.IS_BROWSER) {
          if (window && window.sessionStorage) {
            window.sessionStorage.clear();
          }

          _cookieUtils.default.deleteCookie('authToken');

          _cookieUtils.default.deleteCookie('isAuthenticated'); // navigate to login


          window.location.replace(urlToRedirectTo);
        }

        return result;
      })
    };
  };
}

function requestPasswordReset(username) {
  return {
    type: _authActionKeys.default.REQUEST_PASSWORD_RESET,
    payload: _authService.default.requestPasswordReset(username)
  };
}

function resetPassword(resetId, newPassword) {
  return {
    type: _authActionKeys.default.RESET_PASSWORD,
    payload: _authService.default.resetPassword(resetId, newPassword)
  };
}

function resetPasswordAndLogin(resetId, newPassword) {
  return {
    type: _authActionKeys.default.RESET_PASSWORD_AND_LOGIN,
    payload: _authService.default.resetPasswordAndLogin(resetId, newPassword).then(function (result) {
      if (process.env.IS_BROWSER) {
        (0, _authUtils.setHaTaskTaxonomyTestCookie)(); // Check if server set the cookie, if not add it here

        var r = /.*angieslist\.com$/;

        if ((process.env.NODE_ENV === 'development' || !r.test(location.hostname)) && (0, _get2.default)(result, 'body.authToken')) {
          var expireDate = new Date();
          expireDate.setYear(expireDate.getFullYear() + 1);

          _cookieUtils.default.setCookie('authToken', result.body.authToken, expireDate.toGMTString());
        }
      }

      return result;
    })
  };
}

function getPasswordResetInfo(resetId) {
  return {
    type: _authActionKeys.default.GET_PASSWORD_RESET_INFO,
    payload: _authService.default.getPasswordResetInfo(resetId)
  };
}

function sendMagicLink(applicationName, path, email, payload) {
  return {
    type: _authActionKeys.default.SEND_MAGIC_LINK,
    payload: _authService.default.sendMagicLink(applicationName, path, email, payload)
  };
}

function validateMagicLink(magicToken) {
  return {
    type: _authActionKeys.default.VALIDATE_MAGIC_LINK,
    payload: _authService.default.validateMagicLink(magicToken)
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/auth/authActions.js
// module id = 432
// module chunks = 25